<div class="tw-bg-orange-25 tw-border tw-border-solid tw-border-orange-100 tw-rounded-3 tw-shadow-z4 tw-overflow-hidden tw-relative tw-flex tw-items-center"
     (click)="onSeeTestsClick()">
  <div class="tw-w-1 tw-self-stretch tw-bg-orange-400 tw-shrink-0"></div>
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-flex-1 tw-py-3 tw-pl-3 tw-pr-4">
    <div class="tw-flex tw-gap-2 tw-items-center tw-min-w-0">
      <div class="tw-bg-orange-400 tw-rounded-full tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-shrink-0">
        <img src="/assets/icons/blood.svg" alt="" class="tw-w-6 tw-h-6">
      </div>
      <span class="tw-font-lexend tw-font-bold tw-text-300 tw-leading-1.2 tw-text-black" i18n="@@bloodTestRequested">Blood test requested<br>by your doctor</span>
    </div>
    <button class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-h-6 tw-py-1 tw-bg-teal-600 tw-rounded-1.5 tw-font-lexend tw-font-semibold tw-text-200 tw-text-white tw-whitespace-nowrap tw-shrink-0" i18n="@@seeTests">See Tests</button>
  </div>
</div>
